import ordersApi from './OrdersEndpoint';
import ApiClientBase from './ApiClientBase';
import {
  ListSurgeryAttachmentsResponse,
  SurgeriesRequest,
  SurgeriesResponse,
  SurgeryCancelRequest,
  SurgeryCancelResponse,
  SurgeryNotifyCheckedOutRequest,
  SurgeryNotifyCheckedOutResponse,
  SurgeryUpdateRequest,
} from 'api/models/Surgeries';
import { ShipperDetails } from 'api/models/Deliveries';
import { TimeStampResponse } from 'api/models/TimeStamps';

class SurgeriesEndpoint extends ApiClientBase {
  apiUri = '/api/v2/surgeries';

  // this is just an alias of ordersApi.getOrders in FE and BE
  getSurgeries(params: SurgeriesRequest) {
    return ordersApi.getOrders.bind(this)(params) as Promise<SurgeriesResponse>;
  }

  /*
  createSurgery(payload: SurgeryCreateRequest) {
    return this.apiCall<SurgeryCreateResponse>('/', 'post', payload, ORDERS_UPLOAD_AXIOS_OPTIONS);
  }
  */

  updateSurgery(request: SurgeryUpdateRequest) {
    return this.apiCall('/', 'put', request);
  }

  cancelSurgery(request: SurgeryCancelRequest) {
    return this.apiCall<SurgeryCancelResponse>('/cancel_surgery/', 'put', request);
  }

  getSurgeryAttachments(orderRecordId: string) {
    return this.apiCall<ListSurgeryAttachmentsResponse>(`/${orderRecordId}/attachments/`, 'get');
  }

  deleteSurgeryAttachment(orderRecordId: string, attachmentId: string) {
    return this.apiCall(`/${orderRecordId}/attachments/${attachmentId}/`, 'delete');
  }

  notifySurgeryCheckedOut({ surgeryId, returnDetails, returnedByRepId }: SurgeryNotifyCheckedOutRequest) {
    return this.apiCall<SurgeryNotifyCheckedOutResponse>(`/${surgeryId}/send_checkout_email/`, 'post', {
      returnDetails,
      returnedByRepId,
    });
  }

  getPrintDeliveryNoteCheckOut({
    surgeryId,
    returnDetails,
    returnedByRepId,
  }: {
    surgeryId: string | number;
    returnDetails?: ShipperDetails;
    returnedByRepId?: string;
  }) {
    const uri = `/${surgeryId}/print_surgery_checkout_delivery_note/`;
    return this.apiCall({
      uri,
      method: 'post',
      cfg: { responseType: 'blob', timeout: 2 * 60 * 1000 },
      data: { checkoutDetails: returnDetails, returnedByRepId },
    });
  }

  getTimeStamps(orderRecordId: string) {
    return this.apiCall<TimeStampResponse>(`/${orderRecordId}/time_stamps`);
  }
}

const surgeries = new SurgeriesEndpoint();

export default surgeries;
